import { isPlatform } from "@ionic/react"

export const baseUrl = process.env.REACT_APP_BASE_URL || "https://doctor-rx.medicalquizz.com/"
export const apiBaseUrl = baseUrl + "api/"
export const storageBaseUrl = baseUrl + "storage/"
export const appSubDir = "/"
export const doseText = { '1': '1 Time (OD) / Daily', '2': '2 Times (BD) / 12 Hourly', '3': '3 Times (TDS) / 8 Hourly', '4': '4 Times (QDS) / 6 Hourly' }
// export const paymentMethod = 'amarpay' as string
export const paymentMethod = 'sslc' as string
export const isWebIosApp = (window.location.hostname === "dra.medicalquizz.com")
export const isWebApp = (window.location.hostname === 'droid.medicalquizz.com')
// export const isWebApp = !isPlatform('capacitor')
export const isAndroidApp = isPlatform('android') && !isWebApp
export const debugMode = process.env.REACT_APP_DEBUG_MODE || false
export const fcmTopicSuffix = process.env.REACT_APP_FCM_TOPIC_SUFFIX || 'test-notification'